// Main Descriptors
import enUS from './en-US/descriptors';

// Rest of translation resources
import { nonDescriptorMessages as enUSNonDescriptorMessages } from './en-US/messages';
import daDK, {
  nonDescriptorMessages as daDKNonDescriptorMessages
} from './da-DK/messages';
import deDE, {
  nonDescriptorMessages as deDENonDescriptorMessages
} from './de-DE/messages';
import enGB, {
  nonDescriptorMessages as enGBNonDescriptorMessages
} from './en-GB/messages';
import es419, {
  nonDescriptorMessages as es419NonDescriptorMessages
} from './es-419/messages';
import esES, {
  nonDescriptorMessages as esESNonDescriptorMessages
} from './es-ES/messages';
import frFR, {
  nonDescriptorMessages as frFRNonDescriptorMessages
} from './fr-FR/messages';
import itIT, {
  nonDescriptorMessages as itITNonDescriptorMessages
} from './it-IT/messages';

import _ from 'lodash';
import { IMessageDescriptor, messagesToDescriptors } from '@hcecbp/i18n-utils';

// Descriptors to i18next translation object
const _descriptorToTranslation = (
  input: Record<string, Record<string, IMessageDescriptor>>,
  nonDescriptorMessages: Record<string, string> = {}
): { translation: Record<string, string> } => {
  const retMap: Record<string, string> = {};
  _.forEach(input, (_d: Record<string, IMessageDescriptor>) => {
    _.forEach(_d, (v: IMessageDescriptor) => {
      retMap[v.id] = v.defaultMessage;
    });
  });
  return { translation: { ...nonDescriptorMessages, ...retMap } };
};

export const translations = {
  'en-US': _descriptorToTranslation(enUS, enUSNonDescriptorMessages),
  'da-DK': _descriptorToTranslation(
    messagesToDescriptors(daDK),
    daDKNonDescriptorMessages
  ),
  'de-DE': _descriptorToTranslation(
    messagesToDescriptors(deDE),
    deDENonDescriptorMessages
  ),
  'en-GB': _descriptorToTranslation(
    messagesToDescriptors(enGB),
    enGBNonDescriptorMessages
  ),
  'es-419': _descriptorToTranslation(
    messagesToDescriptors(es419),
    es419NonDescriptorMessages
  ),
  'es-ES': _descriptorToTranslation(
    messagesToDescriptors(esES),
    esESNonDescriptorMessages
  ),
  'fr-FR': _descriptorToTranslation(
    messagesToDescriptors(frFR),
    frFRNonDescriptorMessages
  ),
  'it-IT': _descriptorToTranslation(
    messagesToDescriptors(itIT),
    itITNonDescriptorMessages
  )
};
